import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/trash-multiple-documents.scss";
import { pluralize } from "utils/string-helpers";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const DeletePermanentlyModal = ({
  isDeletePermanentlyLoading,
  isDeletePermanentlyVisible,
  onDeletePermanently,
  onHideDeletePermanently,
  selectedIds
}) => (
  <Modal
    isVisible={ isDeletePermanentlyVisible }
    onClose={ onHideDeletePermanently }
    transitionName={ "delete-permanently" }
  >
    <div>
      <h3>Delete { pluralize(selectedIds.length, "documents", "document") } permanently?</h3>
      <p>
        (You will not be able to access
        { pluralize(selectedIds.length, " these documents ", " this document ", false) }
        again)
      </p>
      <div className={ styles.buttons }>
        <Button link onClick={ onHideDeletePermanently }>cancel</Button>
        <Button
          danger
          loading={ isDeletePermanentlyLoading }
          onClick={ onDeletePermanently }
        >
          Delete Permanently
        </Button>
      </div>
    </div>
  </Modal>
);

DeletePermanentlyModal.propTypes = {
  isDeletePermanentlyLoading: PropTypes.bool.isRequired,
  isDeletePermanentlyVisible: PropTypes.bool.isRequired,
  onDeletePermanently: PropTypes.func.isRequired,
  onHideDeletePermanently: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/delete-permanently-modal.jsx